/** Whether a className string holds `name`, split on any whitespace as CSS does. */
export function hasClass(className: string | undefined, name: string): boolean {
  return (className ?? '').split(/\s+/).includes(name);
}
